import MapComponent from "./Map.Component"
import { Helpers } from "./Map.helpers"
import Actions from "./Map.actions"

export default {
    Compenent:MapComponent,
    Helpers,
    Actions
}